<template>

  <b-img v-bind="attributes" :src="imgSrc"></b-img>

</template>

<script>
  import {mapActions} from 'vuex';
  import Camera from '@/mixins/camera';

  export default {
    name: 'camera-live-view',
    props: {
      printerId: {
        type: [Number, String],
        required: true
      },
      webcamId: {
        type: [Number, String]
      },
      width: {
        type: [Number, String]
      },
      height: {
        type: [Number, String]
      },
      center: {
        type: Boolean,
        default: true
      },
      thumbnail: {
        type: Boolean,
        default: true
      }
    },
    mixins: [Camera],
    data() {
      return {
        error: false,
        hasListHeartbeat: false,
        cameraListToken: null,
        defaultWebcamId: 0,
        rotate: false,
        service: null,
        listStream: null,
        frameStream: null,
        isBase64: false,
        imgSrc: this.getConnectionImage(),
        selectedWebcamId: null
      }
    },
    created() {
      this.selectedWebcamId = this.webcamId;
      this.startCameraStream();
    },
    beforeDestroy() {
      this.detachStreams();
    },
    computed: {
      attributes() {
        let attrs = {};
        if (this.width) {
          attrs.width = this.width;
        }
        if (this.height) {
          attrs.height = this.height;
        }
        if (Object.keys(attrs).length === 0) {
          attrs.fluid = true;
        }
        attrs.center = this.center;
        attrs.thumbnail = this.thumbnail;

        return attrs;
      }
    },
    methods: {
      ...mapActions(['getCameraListToken']),

      startCameraStream() {
        this.detachStreams();
        this.getCameraListToken(this.printerId).then(({data}) => {
          if (data.result) {
            this.cameraListToken = data.message.token;
            this.defaultWebcamId = data.message.webcam_id;
            this.rotate = data.message.rotate;
            this.listStream = this.allocateGrpcService().streamCameraList(
              this.cameraListToken,
              this._handleCameraListStreamData,
              this._handleCameraListStreamError
            );
          } else {
            this.error = true;
          }
        }).catch(() => this.error = true);
      },

      _handleCameraListStreamData(data, type) {
        if (type === 'data') {
          if (this.selectedWebcamId === null || this.selectedWebcamId === undefined) {
            //Select first camera in list if not selected
            this.selectedWebcamId = data.getCameraName();
          }
          if (data.getJustHeartbeat()) {
            if (!this.hasListHeartbeat) {
              this.hasListHeartbeat = true;
              setTimeout(() => {
                if (this.imgSrc === this.getConnectionImage()) {
                  this.imgSrc = this.getNoCameraImage();
                }
              }, 3000);
            }
            return;
          }
          if (data.getCameraName() == this.selectedWebcamId) {
            if (this.frameStream) {
              console.log('NOT ACTIVE: CANCEL FRAME');
              this.frameStream.cancel();
            }
            if (data.getActive()) {
              this.isBase64 = data.getBase64();
              this.frameStream = this.allocateGrpcService().streamCameraFrame(
                data.getFrameStreamToken(),
                this._handleCameraFrameStreamData,
                this._handleCameraFrameStreamError
              );
            } else {
              this.imgSrc = this.getNoCameraImage();
            }
          }
        }
      },

      _handleCameraListStreamError(e) {
        //TODO: handle errors
        this.imgSrc = this.getNoCameraImage();
        console.log(e);
      },

      _handleCameraFrameStreamData(frame) {
        if (frame.getJustHeartbeat() || frame.getFrame().length <= 1) {
          return;
        }
        this.imgSrc = this.convertFrameToUrlData(frame, this.isBase64);
      },

      _handleCameraFrameStreamError(e) {
        //TODO: handle errors
        this.imgSrc = this.getNoCameraImage();
        console.log(e);
      },

      detachStreams() {
        this.hasListHeartbeat = false;
        if (this.listStream) {
          this.listStream.cancel();
          this.listStream = null;
        }
        if (this.frameStream) {
          this.frameStream.cancel();
          this.frameStream = null;
        }
      }
    },

    watch: {
      webcamId: function(newVal) {
        this.selectedWebcamId = newVal;
      }
    }
  }
</script>

<style scoped>
  .camera-stream {
    width: 640px;
    height: 480px;
  }
</style>
